import { Provider } from '@angular/core';
import { OnboardService } from './services/onboard.service';

export const ONBOARD_PROVIDERS: Provider[] = [OnboardService];
